import { LANGLOCALE, WINDOW } from '@myre/ui-primitive-core';

import { DOCUMENT } from '@angular/common';
import {
  inject,
  makeEnvironmentProviders,
  Type,
  type EnvironmentProviders,
} from '@angular/core';

import { ZendeskMocked } from './zendesk.mocked';
import { AZendeskConfig } from './zendesk.model';
import { ZendeskService } from './zendesk.service';

export class ZendeskConfig extends AZendeskConfig {
  public accountUrl: string = 'myre.zendesk.com';

  private readonly _lang = inject(LANGLOCALE);

  public beforePageLoad = (zE: any): void => {
    zE.setLocale(this._lang);
    zE.hide();
  };
}

export function provideZendesk(
  zendeskConfig: Type<AZendeskConfig>,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: AZendeskConfig,
      useClass: zendeskConfig,
      deps: [LANGLOCALE],
    },
    {
      provide: ZendeskService,
      useClass: window.myreEnvironment?.zendeskEnabled
        ? ZendeskService
        : ZendeskMocked,
      deps: [WINDOW, DOCUMENT, AZendeskConfig],
    },
  ]);
}
